'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _EducationForm = require('../ui/EducationForm');

var _EducationForm2 = _interopRequireDefault(_EducationForm);

var _LogentryModel = require('../../logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _PersonModel = require('../../person/model/PersonModel');

var _PersonModel2 = _interopRequireDefault(_PersonModel);

var _EducationModel = require('../model/EducationModel');

var _EducationModel2 = _interopRequireDefault(_EducationModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditEducation = function EditEducation(element, args) {
  var _this = this;

  _classCallCheck(this, EditEducation);

  this.onchange = function () {
    _this.data = _this.educationForm.getValue();

    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('educations', _this.data.getJSON()).then(function (education) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && education.id) {
        window.PRIM.navigate('/educations/' + education.id, true);
      }

      if (education) {
        _this.data.values.id = education.id;
        _this.educationForm.setValue(_this.data);
      }
    });
  };

  if (args) {
    if (args.id) {
      window.PRIM.dataAccess.resolve('educations', args.id, true).then(function (education) {
        _this.data = education;
        _this.educationForm.setValue(_this.data);

        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
          var results = logentries.filter(function (logentry) {
            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.education;
          });

          _this.data.logentries = results.map(function (logentry) {
            return new _LogentryModel2.default(logentry);
          });

          _this.logIndex.setItems(_this.data.logentries);
        }, function () {}).catch(function () {});
      }, function () {
        if (confirm('Deze opleiding bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
          window.PRIM.navigate('/educations/');
        } else {
          history.back();
        }
      }).catch(function () {});
    } else if (args.person_id) {
      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
        _this.data = new _PersonModel2.default();
        _this.data.values.person_id = person.values.id;
        _this.data.person = person;
        _this.educationForm.setValue(_this.data);
      });
    }
  }

  this.data = new _EducationModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Opleiding bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/logentries/education/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze opleiding.');
        }
      },
      icon: '\uE032',
      label: 'Logboekregel'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze opleiding wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('educations', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze opleiding.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  var primaryData = document.createElement('section');
  primaryData.className = 'primary';
  var secondaryData = document.createElement('section');
  secondaryData.className = 'secondary';

  this.educationForm = new _EducationForm2.default(primaryData, { education: this.data, onchange: this.onchange });

  var fieldsetLog = document.createElement('fieldset');
  var legendLog = document.createElement('legend');
  legendLog.innerHTML = 'Logboek';
  fieldsetLog.appendChild(legendLog);

  var onclickLogentry = function onclickLogentry(item) {
    window.PRIM.navigate('/logentries/' + item.values.id);
  };

  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });

  secondaryData.appendChild(fieldsetLog);

  divContent.appendChild(primaryData);
  divContent.appendChild(secondaryData);
  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditEducation;


//////////////////
// WEBPACK FOOTER
// ./js/modules/education/action/EditEducation.js
// module id = 58
// module chunks = 0